// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hs-6";
export var emphasizeQuantity = "_hs-3";
export var flatBottomCorners = "_hs-5";
export var productImage = "_hs-0";
export var quantityContainer = "_hs-2";
export var tooltip = "_hs-1";
export var wrapAndEllipsesOverflow = "_hs-4";